  // actions.js

  export const storeAllCardDetails = allCardDetails => ({
    type: 'ALL_CARD_DETAILS',
    allCardDetails
  });

  export const storeCardDetails = cardDetails => {
    return {
      type: 'CARD_DETAILS',
      cardDetails
    };
  }

  export const getCardData = () => ({
    type: 'GET_CARD_DATA'
  });

  export const appliedSimulator = () => ({
    type: 'APPLIED_SIMULATOR',
  });

  export const removedSimulator = () => ({
    type: 'REMOVED_SIMULATOR',
  });

  export const storeFilterValue = (filterAttribute) => ({
    type: 'FILTER_ATTRIBUTE',
    filterAttribute,
  });

  export const storeSimulatorValue = (simulatorValue) => ({
    type: 'SIMULATOR_VALUE',
    simulatorValue,
  });

  export const storeCategoryCardCount = ({typeCountObj, cardFeatureCountObj, cardBankCountObj, cardPremiumCountObj}) => {

    return {
      type: 'CATEGORY_LIST',
      typeCountObj,
      cardFeatureCountObj,
      cardBankCountObj,
      cardPremiumCountObj,
    }
  };

  export const compareCardData = (compareCardData) => ({
    type: 'COMPARE_CARD_DATA',
    compareCardData,
  });

  export const storeSimulateEmail = (email, allowInput) => ({
    type: 'STORE_SIMULATE_EMAIL',
    email,
    allowInput,
  });

  export const applySuccess = (message, success) => ({
    type: 'APPLY_SUCCESS',
    success,
    message,
  });

  export const makeapplySuccess = (message, success) => ({
    type: 'APPLY_SUCCESS',
    success,
    message,
  });

  export const setGotCardDataFromApi = (reset) => ({
    type: 'SET_GOT_CARD_DATA_FROM_API',
    reset,
  })

  // loans

  export const storeAllLoanDetails = allLoanDetails => ({
    type: 'ALL_LOAN_DETAILS',
    allLoanDetails
  });

  export const storeLoanDetails = loanDetails => ({
    type: 'LOAN_DETAILS',
    loanDetails
  });

  export const getLoanData = () => ({
    type: 'GET_LOAN_DATA',
  });
  // uncomment for lang
  // export const getLoanData = (activeLanguage) => ({
  //   type: 'GET_LOAN_DATA',
  //   activeLanguage,
  // });

  export const appliedEmi = () => ({
    type: 'APPLIED_EMI',
  });

  export const removedEmi = () => ({
    type: 'REMOVED_EMI',
  });

  export const setAppliedCustomOffer = () => ({
    type: 'APPLIED_CUSTOM_OFFER',
  });

  export const removedCustomOffer = () => ({
    type: 'REMOVED_CUSTOM_OFFER',
  });

  export const storeLoanFilterValue = (filterAttribute) => ({
    type: 'LOAN_FILTER_ATTRIBUTE',
    filterAttribute,
  });

  export const storeLoanSimulatorValue = (simulatorValue) => ({
    type: 'LOAN_SIMULATOR_VALUE',
    simulatorValue,
  });

  export const storeCategoryLoanCount = ({typeCountObj, loanFeatureCountObj, loanBankCountObj}) => ({
    type: 'LOAN_CATEGORY_LIST',
    typeCountObj,
    loanFeatureCountObj,
    loanBankCountObj,
  });

  export const compareLoanData = (compareLoanData) => ({
    type: 'COMPARE_LOAN_DATA',
    compareLoanData,
  });

  export const storeEmiInputValue = (emiInputValue) => ({
    type: 'LOAN_EMI_ATTRIBUTE',
    emiInputValue,
  });

  export const storeEmiEmail = (email, allowInput) => ({
    type: 'STORE_EMI_EMAIL',
    email,
    allowInput,
  });

  export const setGotLoanDataFromApi = (reset) => ({
    type: 'SET_GOT_LOAN_DATA_FROM_API',
    reset,
  })

  // Car loans

  export const storeAllAutoLoanDetails = allAutoLoanDetails => ({
    type: 'ALL_AUTO_LOAN_DETAILS',
    allAutoLoanDetails
  });

  export const storeAutoLoanDetails = autoLoanDetails => ({
    type: 'AUTO_LOAN_DETAILS',
    autoLoanDetails
  });

  export const getAutoLoanData = () => ({
    type: 'GET_AUTO_LOAN_DATA'
  });

  export const appliedAutoLoanEmi = () => ({
    type: 'APPLIED_AUTO_LOAN_EMI',
  });

  export const removedAutoLoanEmi = () => ({
    type: 'REMOVED_AUTO_LOAN_EMI',
  });

  export const storeAutoLoanFilterValue = (filterAttribute) => ({
    type: 'AUTO_LOAN_FILTER_ATTRIBUTE',
    filterAttribute,
  });

  export const storeAutoLoanSimulatorValue = (simulatorValue) => ({
    type: 'AUTO_LOAN_SIMULATOR_VALUE',
    simulatorValue,
  });

  export const storeCategoryAutoLoanCount = ({typeCountObj, autoLoanFeatureCountObj, carTypesCountObj, autoLoanBankCountObj}) => ({
    type: 'AUTO_LOAN_CATEGORY_LIST',
    typeCountObj,
    autoLoanFeatureCountObj,
    carTypesCountObj,
    autoLoanBankCountObj,
  });

  export const compareAutoLoanData = (compareAutoLoanData) => ({
    type: 'COMPARE_AUTO_LOAN_DATA',
    compareAutoLoanData,
  });

  export const storeAutoLoanEmiInputValue = (emiInputValue) => ({
    type: 'AUTO_LOAN_EMI_ATTRIBUTE',
    emiInputValue,
  });

  export const setGotAutoLoanDataFromApi = (reset) => ({
    type: 'SET_GOT_AUTO_LOAN_DATA_FROM_API',
    reset,
  })

  // mortgage loans

  export const storeAllMortgageLoanDetails = allMortgageLoanDetails => ({
    type: 'ALL_MORTGAGE_LOAN_DETAILS',
    allMortgageLoanDetails
  });

  export const storeMortgageLoanDetails = mortgageLoanDetails => ({
    type: 'MORTGAGE_LOAN_DETAILS',
    mortgageLoanDetails
  });

  export const getMortgageLoanData = () => ({
    type: 'GET_MORTGAGE_LOAN_DATA'
  });

  export const appliedMortgageLoanEmi = () => ({
    type: 'APPLIED_MORTGAGE_LOAN_EMI',
  });

  export const removedMortgageLoanEmi = () => ({
    type: 'REMOVED_MORTGAGE_LOAN_EMI',
  });

  export const storeMortgageLoanFilterValue = (filterAttribute) => ({
    type: 'MORTGAGE_LOAN_FILTER_ATTRIBUTE',
    filterAttribute,
  });

  export const storeMortgageLoanSimulatorValue = (simulatorValue) => ({
    type: 'MORTGAGE_LOAN_SIMULATOR_VALUE',
    simulatorValue,
  });

  export const storeCategoryMortgageLoanCount = ({typeCountObj, mortgageLoanPropertyTypeCountObj, mortgageLoanBankCountObj}) => ({
    type: 'MORTGAGE_LOAN_CATEGORY_LIST',
    typeCountObj,
    mortgageLoanPropertyTypeCountObj,
    mortgageLoanBankCountObj,
  });

  export const compareMortgageLoanData = (compareMortgageLoanData) => ({
    type: 'COMPARE_MORTGAGE_LOAN_DATA',
    compareMortgageLoanData,
  });

  export const storeMortgageLoanEmiInputValue = (emiInputValue) => ({
    type: 'MORTGAGE_LOAN_EMI_ATTRIBUTE',
    emiInputValue,
  });

  export const setGotMortgageLoanDataFromApi = (reset) => ({
    type: 'SET_GOT_MORTGAGE_LOAN_DATA_FROM_API',
    reset,
  })

  // export const getHomeData = () => ({
  //   type: 'GET_HOME_DATA'
  // });

  //bank accounts
  export const storeAllBankAccountDetails = allBankAccountDetails => ({
    type: 'ALL_BANK_ACCOUNT_DETAILS',
    allBankAccountDetails
  });

  export const storeBankAccountDetails = bankAccountDetails => ({
    type: 'BANK_ACCOUNT_DETAILS',
    bankAccountDetails
  });

  export const getBankAccountData = () => ({
    type: 'GET_BANK_ACCOUNT_DATA'
  });

  export const storeBankAccountFilterValue = (filterAttribute) => ({
    type: 'BANK_ACCOUNT_FILTER_ATTRIBUTE',
    filterAttribute,
  });

  export const compareBankAccountData = (compareBankAccountData) => ({
    type: 'COMPARE_BANK_ACCOUNT_DATA',
    compareBankAccountData,
  });

  export const setGotBankAccountDataFromApi = (reset) => ({
    type: 'SET_GOT_BANK_ACCOUNT_DATA_FROM_API',
    reset,
  })

  export const storeCategoryBankAccCount = ({typeCountObj, bankAccFeatureCountObj, bankAccBankCountObj, bankAccPremiumCountObj}) => {

    return {
      type: 'BANK_ACCOUNT_CATEGORY_LIST',
      typeCountObj,
      bankAccFeatureCountObj,
      bankAccBankCountObj,
      bankAccPremiumCountObj,
    }
  };

  // common

  export const storeApplyFormInput = (formInput) => ({
    type: 'APPLY_INPUT_FORM',
    formInput,
  });

  export const storeApplyInsuranceFormInput = (formInput) => ({
    type: 'APPLY_INSURANCE_INPUT_FORM',
    formInput,
  });

  export const setActiveLanguage = (activeLanguage) => ({
    type: 'ACTIVE_LANGUAGE',
    activeLanguage
  });

  export const storeProduct = (product) => ({
    type: 'STORE_PRODUCT',
    product
  });

  export const storeUserId = (userId) => ({
    type: 'STORE_USER_ID',
    userId
  });




// WEBPACK FOOTER //
// ./src/redux/actions.js